import { InvoiceViewModel } from '@fora-monorepo/employer-my-pages-common/types';
import { HeadCellSortState } from '@foradevelopment/fora-ui';

import type { InvoicesTableSortId } from '../types';
import { sortNumber, sortStringBasic } from './comparisonFunctions';

type TableSortState = {
  [key in InvoicesTableSortId]?: HeadCellSortState;
};

export const sortInvoicesListIndices = ({
  invoicesList,
  sortState,
  indices,
}: {
  invoicesList: InvoiceViewModel[];
  sortState: TableSortState;
  indices?: number[];
}): number[] => {
  let invoiceListIndices: number[] = [];
  if (invoicesList) {
    invoiceListIndices = invoicesList.map((_, ind) => ind);
  }
  if (Object.keys(sortState).every(state => state === HeadCellSortState.None)) {
    return indices ?? invoiceListIndices;
  }

  // If indices is not empty, sort filtered employments
  const indicesToSort = indices ?? invoiceListIndices;

  return indicesToSort.sort((a: number, b: number) => {
    const invoiceA = invoicesList[a];
    const invoiceB = invoicesList[b];

    // Default sorting by invoice number (id)
    if (sortState.ocrNumber) {
      return sortNumber(Number(invoiceA.ocr), Number(invoiceB.ocr), sortState.ocrNumber === HeadCellSortState.Asc);
    }
    // Sorting by invoice status
    if (sortState.invoiceStatus) {
      if (invoiceA.status || invoiceB.status) {
        return sortStringBasic(
          invoiceA.status ?? '',
          invoiceB.status ?? '',
          sortState.invoiceStatus === HeadCellSortState.Asc
        );
      }
    }
    // Sorting by invoice type
    if (sortState.invoiceType) {
      return sortStringBasic(
        invoiceA.invoiceType,
        invoiceB.invoiceType,
        sortState.invoiceType === HeadCellSortState.Asc
      );
    }
    // Sorting by invoice date
    if (sortState.invoiceDate) {
      return sortStringBasic(
        invoiceA.invoiceDate,
        invoiceB.invoiceDate,
        sortState.invoiceDate === HeadCellSortState.Asc
      );
    }
    // Sorting by expiration date (due date)
    if (sortState.invoiceDueDate) {
      return sortStringBasic(
        invoiceA.invoiceDueDate,
        invoiceB.invoiceDueDate,
        sortState.invoiceDueDate === HeadCellSortState.Asc
      );
    }
    // Sorting by invoice amount
    if (sortState.invoiceAmount) {
      if (invoiceA.amount || invoiceB.amount) {
        return sortNumber(
          invoiceA.amount ?? 0,
          invoiceB.amount ?? 0,
          sortState.invoiceAmount === HeadCellSortState.Asc
        );
      }
    }
    return 0;
  });
};
